// extracted by mini-css-extract-plugin
export default {"receiptCell":"TableDownloadCYVisitReceiptCell_receiptCell__LiC05"};